import { Overrides } from '@material-ui/core/styles/overrides';
import pallete from '../palette';

const MuiCheckbox: Overrides['MuiCheckbox'] = {
  colorSecondary: {
    '&$checked': {
      color: pallete.primary.dark,
    },
  },
};

export default MuiCheckbox;
